import React from 'react';
import ReportPageShell from './ReportPageShell';
import { REPORT_DOCUMENT_TYPES } from '../../utils/reportDocumentTypes';

export default function ResultPage() {
  return <ReportPageShell documentType={REPORT_DOCUMENT_TYPES.RESULT} />;
}
